// Pour naviguer vers le login de home (ni /res ni /pro, mais leur login chapeau nommé home)
// C'est utilisé dans le projet home pour rediriger vers le login de home.

const ROUTE_TO_HOME_LOGIN = '/login';
// const PREFIX_TO_B2C = process.env.REACT_APP_B2C_PREFIX || '';
const PREFIX_TO_B2B = process.env.REACT_APP_B2B_PREFIX || '';
const PREFIX_TO_B2C_THERMIQUE = process.env.REACT_APP_B2C_THERMIQUE_PREFIX || '';
//  const ROUTE_TO_SELECTOR = `/b2b-b2c-selector`;
const ROUTE_TO_EA = '/espace-agent';

export const redirectToHomeLogin = (): void => {
    const redirectUrl = `${window.location.origin}${ROUTE_TO_HOME_LOGIN}`;
    console.log('Home routing redirect redirectToHomeLogin ' + redirectUrl);
    window.location.replace(redirectUrl);
};
// export const redirectToHomeSelector = (): void => {
//     const redirectUrl = `${window.location.origin}${ROUTE_TO_SELECTOR}`;
//     console.log('Home routing redirect redirectToHomeSelector ' + redirectUrl);
//     window.location.href = redirectUrl;
// };
// export const redirectToB2CEA = (): void => {
//     const redirectUrl = `${window.location.origin}${PREFIX_TO_B2C}${ROUTE_TO_EA}`;
//     console.log('Home routing redirect redirectToB2CEA ' + redirectUrl);
//     window.location.href = redirectUrl;
// };
export const redirectToB2BEA = (): void => {
    const redirectUrl = `${window.location.origin}${PREFIX_TO_B2B}${ROUTE_TO_EA}`;
    console.log('Home routing redirect redirectToB2BEA ' + redirectUrl);
    window.location.href = redirectUrl;
};
export const redirectToB2CThermique = (): void => {
    const redirectUrl = `${window.location.origin}${PREFIX_TO_B2C_THERMIQUE}`;
    console.log('Home routing redirect redirectToB2BEA ' + redirectUrl);
    window.location.href = redirectUrl;
};
